(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-type-slideshow"] && !Shopify.designMode) return;
  try {
    
  function run_slide_show() {
    const slideShowElem = document.querySelector('.slide-show');
    const slideItems = document.querySelectorAll('.slide-item-container');
    const slideIndicatorElems = document.querySelectorAll('.slide-indicator-item');

    if (!slideItems.length) return;

    // Initial Active State
    if (slideIndicatorElems.length > 0) {
      slideIndicatorElems[0].classList.add('slide-indicator-active');
    }

    const slideDur = slideShowElem.dataset.slideDuration;
    const slideAnimDur = slideShowElem.dataset.slideAnimDuration;
    const numItems = slideItems.length;

    let currentSlide = 0;
    let currentPos = 0;
    let isAnimating = false;
    let slideInterval;

    const intervalTime = parseInt(slideDur);
    const animTime = parseInt(slideAnimDur);

    // Easing function
    function easeInOutSine(x) {
      return -(Math.cos(Math.PI * x) - 1) / 2;
    }

    // --- Core Logic to Change Slide ---
    function change_slide(targetIndex) {
      if (isAnimating || targetIndex === currentSlide) return;
      isAnimating = true;

      const viewportWidth = window.innerWidth;
      const startPos = currentPos;

      currentSlide = targetIndex;

      // Handle Video Autoplay
      const currElem = slideItems[currentSlide];
      if (currElem.dataset.mediaType == 'video' && currElem.firstElementChild) {
        currElem.firstElementChild.currentTime = 0;
        currElem.firstElementChild.play().catch((e) => console.log('Auto-play prevented'));
      }

      const targetPos = -currentSlide * viewportWidth;
      let startTime = null;

      function animate(timestamp) {
        if (!startTime) startTime = timestamp;
        const elapsed = timestamp - startTime;
        const progress = Math.min(elapsed / animTime, 1);
        const eased = easeInOutSine(progress);

        currentPos = startPos + (targetPos - startPos) * eased;
        slideShowElem.style.transform = `translateX(${currentPos}px)`;

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          currentPos = targetPos;
          slideShowElem.style.transform = `translateX(${currentPos}px)`;
          isAnimating = false;

          slideIndicatorElems.forEach((elem, i) => {
            if (i == currentSlide) {
              elem.classList.add('slide-indicator-active');
            } else {
              elem.classList.remove('slide-indicator-active');
            }
          });
        }
      }
      requestAnimationFrame(animate);
    }

    // --- Next Slide Wrapper ---
    function next_slide() {
      const nextIndex = (currentSlide + 1) % numItems;
      change_slide(nextIndex);
    }

    // --- Timer Controls ---
    function startTimer() {
      slideInterval = setInterval(next_slide, intervalTime);
    }

    function resetTimer() {
      clearInterval(slideInterval);
      startTimer();
    }

    // --- Event Listeners for Indicators ---
    slideIndicatorElems.forEach((indicator) => {
      indicator.addEventListener('click', function () {
        const index = parseInt(this.dataset.index);
        clearInterval(slideInterval);
        change_slide(index);
        startTimer();
      });
    });

    startTimer();
  }

  if (Shopify.designMode) {
    document.removeEventListener('shopify:section:unload', run_slide_show);
    document.addEventListener('shopify:section:load', run_slide_show);
  }
  document.addEventListener('DOMContentLoaded', run_slide_show);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  const review_containers = document.querySelectorAll('.ocr-content-wrapper');
  const [prev_btn, next_btn] = document.querySelectorAll('.ocr-arrow-container .field__button');
  let current_review_container_index = 0;

  prev_btn.addEventListener('click', (e) => {
    review_containers[current_review_container_index].classList.add('ocr-no-display');
    review_containers[current_review_container_index].classList.remove(
      'ocr-animation-slide-right',
      'ocr-animation-slide-left'
    );
    if (current_review_container_index == 0) {
      current_review_container_index = review_containers.length - 1;
    } else {
      current_review_container_index = current_review_container_index - 1;
    }
    review_containers[current_review_container_index].classList.remove('ocr-no-display');
    review_containers[current_review_container_index].classList.add('ocr-animation-slide-right');
  });
  next_btn.addEventListener('click', (e) => {
    review_containers[current_review_container_index].classList.add('ocr-no-display');
    review_containers[current_review_container_index].classList.remove(
      'ocr-animation-slide-right',
      'ocr-animation-slide-left'
    );
    if (current_review_container_index == review_containers.length - 1) {
      current_review_container_index = 0;
    } else {
      current_review_container_index = current_review_container_index + 1;
    }
    review_containers[current_review_container_index].classList.remove('ocr-no-display');
    review_containers[current_review_container_index].classList.add('ocr-animation-slide-left');
  });

  } catch(e) { console.error(e); }
})();
})();
